import { MessageCircle, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { trackClick } from "@/lib/api";
import { useContact } from "@/lib/contact";

export default function MobileCTABar() {
    const contact = useContact();

    return (
        <div
            data-testid="mobile-sticky-cta-bar"
            className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200/80 bg-white/92 backdrop-blur-md md:hidden"
            style={{ paddingBottom: "max(0.65rem, env(safe-area-inset-bottom))" }}
        >
            <div className="grid grid-cols-[auto_auto_1fr] items-center gap-2.5 px-3.5 pt-2.5">
                <a
                    data-testid="mobile-bar-call"
                    href={contact.telUrl}
                    onClick={() => trackClick("call", "mobile-bar")}
                    aria-label="Call Work Island"
                    className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-brand-blue shadow-sm active:scale-95"
                >
                    <Phone size={18} strokeWidth={2.4} />
                </a>
                <a
                    data-testid="mobile-bar-whatsapp"
                    href={contact.waLink("Hi Work Island, I'd like to book a free demo!")}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackClick("whatsapp", "mobile-bar")}
                    aria-label="WhatsApp Work Island"
                    className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-brand-teal shadow-sm active:scale-95"
                >
                    <MessageCircle size={18} strokeWidth={2.4} />
                </a>
                <button
                    data-testid="mobile-bar-book-demo"
                    onClick={() => scrollToId("#book-demo")}
                    className="btn-gradient flex h-12 items-center justify-center rounded-full text-sm font-bold text-white"
                >
                    Book Free Demo
                </button>
            </div>
        </div>
    );
}
